import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { ReactComponent as AddTeamIcon } from "./Team Icons/Add Team Icon.svg";
import { Link, useNavigate } from "react-router-dom";
import "./addTeam.css";
import AddImage from "../../Global Functions/addImage";
import { addTeamMember } from "../../Redux/Actions/teamMembersAction";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCityListPagination,
  viewCountryListPagination,
  viewStateListPagination,
} from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import { getEnums } from "../../Redux/Actions/enumsActions";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import { ToFirstCapital } from "../../Utils/helpers";

const AddTeamMember = () => {
  const dispatch = useDispatch();

  const todayDate = new Date().toISOString().split("T")[0];

  const { enumsData } = useSelector((state) => state.enumsData);

  useEffect(() => {
    dispatch(getEnums());
  }, [dispatch]);

  const [confirmPass, setConfirmPass] = useState("");
  const [reAccount, setReAccount] = useState("");

  const [memberData, setMemberData] = useState({
    profile_image: "",
    name: "",
    email: "",
    country_code: "",
    contact_number: "",
    role: "",
    timezone: "",
    pwd: "",
    lat: "12",
    lng: "12",
    gender: "",
    age: "",
    dob: "",
    city: "",
    state: "",
    country: "",
    joining_date: "",
    qualifications: [{ degree: "" }],
    experience: "",
    address: "",
    branch_address: "",
    department: "",
    zip_code: "",
    designation: "",
    document_list: [{ name: "", url: "" }],
    bank_details: [
      {
        acc_num: "",
        ifsc: "",
        acc_holder_name: "",
      },
    ],
  });

  const [accMatch, setAccMatch] = useState(true);

  const [stateData, setStateData] = useState({
    country: "",
  });

  const [cityData, setCityData] = useState({
    state: "",
    country: "",
  });

  useEffect(() => {
    dispatch(viewCountryListPagination());
  }, [dispatch]);

  const deptArray = ["payments", "business"];

  const { countryList } = useSelector((state) => state.country);
  const { states } = useSelector((state) => state.states);
  const { cities } = useSelector((state) => state.city);

  const handleImageChange = async (event) => {
    const uploadedImage = event.target.files[0];
    try {
      if (!uploadedImage) return;
      if (uploadedImage) {
        const imageUrl = await AddImage(uploadedImage);
        setMemberData((prevData) => ({ ...prevData, profile_image: imageUrl }));
      }
    } catch (error) {
      console.log(
        "Error in Uploading Image in the Add Image Function",
        error.message
      );
    }
  };

  const navigate = useNavigate();

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setMemberData((prevData) => ({ ...prevData, [name]: value }));
    if (name === "country") {
      setStateData((prevData) => ({ ...prevData, country: value }));
      setCityData((prevData) => ({ ...prevData, country: value }));
    }
    if (name === "state") {
      setCityData((prevData) => ({ ...prevData, state: value }));
    }
  };

  useEffect(() => {
    if (stateData.country !== "") {
      dispatch(viewStateListPagination(stateData));
    }
    if (cityData.state !== "") {
      dispatch(viewCityListPagination(cityData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateData.country, cityData.country, cityData.state]);

  const handleFileChange = async (event, index) => {
    try {
      const uploadedImage = event.target.files[0];
      if (!uploadedImage) return;

      const imageUrl = await AddImage(uploadedImage);
      if (!imageUrl) {
        console.error("Failed to upload image.");
        return;
      }

      setMemberData((prevData) => {
        const updatedDocuments = [...prevData.document_list];

        if (!updatedDocuments[index]) {
          updatedDocuments[index] = { name: "", url: "" };
        }
        updatedDocuments[index].url = imageUrl;
        return { ...prevData, document_list: updatedDocuments };
      });
    } catch (error) {
      console.error("Error uploading file:", error.message);
    }
  };

  const handleNameChange = (event) => {
    const newName = event.target.value;
    setMemberData((prev) => {
      const updatedDocumentList = prev.document_list
        ? [...prev.document_list]
        : [];
      if (updatedDocumentList.length === 0) {
        updatedDocumentList.push({ name: newName, url: "" });
      } else {
        updatedDocumentList[0] = { ...updatedDocumentList[0], name: newName };
      }
      return { ...prev, document_list: updatedDocumentList };
    });
  };

  const handleCheckPass = () => {
    if (confirmPass && memberData.pwd !== confirmPass) {
      return toast.error("Passwords do not match");
    }
  };

  const handleCheckAcc = () => {
    if (reAccount && memberData?.bank_details?.[0]?.acc_num !== reAccount) {
      setAccMatch(false);
      toast.error("Account Numbers Don't Match");
    } else if (
      reAccount &&
      memberData?.bank_details?.[0]?.acc_num === reAccount
    ) {
      setAccMatch(true);
    }
  };

  const handleBankDetails = (event) => {
    const { name, value } = event.target;

    setMemberData((prevData) => ({
      ...prevData,
      bank_details: [
        {
          ...prevData.bank_details[0],
          [name]: value,
        },
      ],
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // 1. Profile Image
    // if (!memberData.profile_image) {
    //   return toast.error("Profile image is required");
    // }

    // 2. Name
    if (!memberData.name.trim()) {
      return toast.error("Name is required");
    }

    // 3. Email
    if (!memberData.email.trim() || !memberData.email.includes("@")) {
      return toast.error("Correct Email is required");
    }

    // 4. Country Code
    if (!memberData.country_code) {
      return toast.error("Country code is required");
    }

    // 5. Contact Number
    if (!memberData.contact_number.trim()) {
      return toast.error("Contact number is required");
    }

    // 6. Role
    if (!memberData.role) {
      return toast.error("Role is required");
    }

    // 7. Designation
    if (!memberData.designation.trim()) {
      return toast.error("Designation is required");
    }

    // 8. Department
    if (!memberData.department) {
      return toast.error("Department is required");
    }

    // 9. Timezone
    if (!memberData.timezone) {
      return toast.error("Time zone is required");
    }

    // 10. Gender
    if (!memberData.gender) {
      return toast.error("Gender is required");
    }

    // 11. Date of Birth
    if (!memberData.dob) {
      return toast.error("Date of birth is required");
    }
    if (new Date(memberData.dob) > new Date()) {
      return toast.error("DOB cannot be in the future");
    }

    // 12. Age
    if (!memberData.age || memberData.age < 0) {
      return toast.error("Valid age is required");
    }

    // 13. Joining Date
    if (!memberData.joining_date) {
      return toast.error("Joining date is required");
    }
    if (new Date(memberData.joining_date) > new Date()) {
      return toast.error("Joining date cannot be in the future");
    }

    // 14. Experience
    if (!memberData.experience || memberData.experience < 0) {
      return toast.error("Valid experience is required");
    }

    // 15. Qualification
    if (!memberData.qualifications?.[0]?.degree) {
      return toast.error("Qualification is required");
    }

    // 16. Password
    if (!memberData.pwd) {
      return toast.error("Password is required");
    }
    if (!confirmPass) {
      return toast.error("Confirm password is required");
    }
    if (memberData.pwd !== confirmPass) {
      return toast.error("Confirm Passwords do not match");
    }

    // 17. Branch address
    if (!memberData.branch_address.trim()) {
      return toast.error("Branch address is required");
    }

    // 18. STREET Address
    if (!memberData.address.trim()) {
      return toast.error("Street address is required");
    }

    // 19. Country/State/City/Zip (Address details)
    if (!memberData.country) {
      return toast.error("Country is required");
    }
    if (!memberData.state) {
      return toast.error("State is required");
    }
    if (!memberData.city) {
      return toast.error("City is required");
    }
    if (!memberData.zip_code) {
      return toast.error("Zip code is required");
    }

    // 20. DOCUMENTS (identity proof)
    const doc = memberData.document_list[0];
    if (!doc || !doc.name.trim() || !doc.url) {
      return toast.error("Identity proof document name and file are required");
    }

    // 21. BANK DETAILS
    // Account number & re-enter validation are handled already in your logic
    if (!memberData.bank_details?.[0]?.acc_num) {
      return toast.error("Account number is required");
    }
    if (!reAccount) {
      return toast.error("Re-enter account number is required");
    }
    if (memberData.bank_details?.[0]?.acc_num !== reAccount) {
      return toast.error("Account numbers do not match");
    }
    if (!memberData.bank_details?.[0]?.ifsc) {
      return toast.error("IFSC code is required");
    }
    if (!memberData.bank_details?.[0]?.acc_holder_name.trim()) {
      return toast.error("Account holder name is required");
    }

    // 22. Proceed only if all above pass
    try {
      const response = await dispatch(addTeamMember(memberData));
      if (response.statusCode === 200) {
        navigate("/team");
      }
      setMemberData({
        // profile_image: "",
        name: "",
        email: "",
        country_code: "",
        contact_number: "",
        role: "",
        timezone: "",
        pwd: "",
        lat: "12",
        lng: "12",
        gender: "",
        age: "",
        dob: "",
        city: "",
        state: "",
        country: "",
        joining_date: "",
        qualifications: [{ degree: "" }],
        experience: "",
        address: "",
        branch_address: "",
        department: "",
        zip_code: "",
        designation: "",
        document_list: [{ name: "", url: "" }],
        bank_details: [
          {
            acc_num: "",
            ifsc: "",
            acc_holder_name: "",
          },
        ],
      });
      setConfirmPass("");
      setReAccount("");
      setAccMatch(true);
    } catch (error) {
      console.log(error);
      toast.error("Failed to add team member");
    }
  };


  return (
    <MainLayout>
      <div className="overall-container-grid">
        <div className="flex-container flex-justify-between align-center span2">
          <div className="top-bar">
            <AddTeamIcon />
            <h1>Add Team Member</h1>
          </div>
          <Link to="/team">
            <button className="view-team-list">View Team List</button>
          </Link>
        </div>
        <h3 style={{ gridColumn: "span 2" }}>Enter Team Member Details</h3>
        <div
          style={{
            gridColumn: "span 1",
            gridRow: "span 2",
            boxSizing: "border-box",
          }}
        >
          <span>Upload Profile Image</span>
          <input
            className="input-class"
            style={{
              display: "none",
            }}
            type="file"
            id="image"
            onChange={(event) => handleImageChange(event)}
            name="image"
          />
          <label className="label" htmlFor="image">
            Click to Upload Image
          </label>
          <ImageShowerModalGlobal
            state={memberData}
            setState={setMemberData}
            keyField="profile_image"
            file={memberData.profile_image}
          />
        </div>
        <div>
          <span>
            Name<span style={{ color: "red" }}>*</span>
          </span>
          <input
            className="input-class"
            type="text"
            name="name"
            onChange={handleAddChange}
            value={memberData.name}
          />
        </div>
        <div>
          <span>
            Email<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            className="input-class"
            type="text"
            name="email"
            value={memberData.email}
          />
        </div>
        <div>
          <span>
            Country Code<span style={{ color: "red" }}>*</span>
          </span>
          <select
            className="input-class"
            type="text"
            name="country_code"
            onChange={handleAddChange}
            value={memberData.country_code}
          >
            <option hidden value="">
              Select An Option
            </option>
            {countryList?.data?.map((country) => (
              <option key={country._id} value={country.country_phone_code}>
                {country.country_phone_code} {country.country_name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <span>
            Phone Number<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            className="input-class"
            type="number"
            name="contact_number"
            value={memberData.contact_number}
          />
        </div>
        <div>
          <span>
            Role<span style={{ color: "red" }}>*</span>
          </span>
          <select
            value={memberData.role}
            onChange={handleAddChange}
            className="input-class"
            type="text"
            name="role"
          >
            <option hidden value="">
              Select an Option
            </option>
            {enumsData?.data?.Roles &&
              Object.entries(enumsData.data.Roles)
                .filter(
                  ([key, value]) =>
                    value !== "admin" &&
                    value !== "super_admin" &&
                    value !== "builder" &&
                    value !== "reviewer"
                )
                .map(([key, value]) => (
                  <option key={key} value={value}>
                    {ToFirstCapital(value)}
                  </option>
                ))}
          </select>
        </div>
        <div>
          <span>
            Designation<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            className="input-class"
            type="text"
            name="designation"
            value={memberData.designation}
          />
        </div>
        <div>
          <span>
            Department<span style={{ color: "red" }}>*</span>
          </span>
          <select
            onChange={handleAddChange}
            value={memberData.department}
            className="input-class"
            type="text"
            name="department"
          >
            <option hidden value="">
              Select an Option
            </option>
            {Array.isArray(deptArray)
              ? deptArray.map((dept) => (
                <option key={dept} value={dept}>
                  {ToFirstCapital(dept)}
                </option>
              ))
              : ["payments", "business"].map((dept) => (
                <option key={dept} value={dept}>
                  {ToFirstCapital(dept)}
                </option>
              ))}
          </select>
        </div>
        <div>
          <span>
            Time Zone<span style={{ color: "red" }}>*</span>
          </span>
          <select
            onChange={handleAddChange}
            value={memberData.timezone}
            className="input-class"
            type="text"
            name="timezone"
          >
            <option hidden value="">
              Select an Option
            </option>
            {enumsData?.data?.time_zones &&
              Object.entries(enumsData.data.time_zones).map(([key, value]) => (
                <option key={key} value={value.offset_UTC}>
                  {value.offset_UTC} ({value.timezone})
                </option>
              ))}
          </select>
        </div>
        <div>
          <span>
            Gender<span style={{ color: "red" }}>*</span>
          </span>
          <select
            value={memberData.gender}
            onChange={handleAddChange}
            className="input-class"
            name="gender"
          >
            <option hidden value="">
              Select an Option
            </option>
            {enumsData?.data?.Gender &&
              Object.entries(enumsData?.data?.Gender).map(([key, value]) => (
                <option key={key} value={value}>
                  {ToFirstCapital(value)}
                </option>
              ))}
          </select>
        </div>
        <div>
          <span>
            Date of Birth<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            className="input-class"
            max={todayDate}
            type="date"
            value={memberData.dob}
            name="dob"
          />
        </div>
        <div>
          <span>
            Age<span style={{ color: "red" }}>*</span>
          </span>
          <input
            value={memberData.age}
            onChange={handleAddChange}
            className="input-class"
            type="number"
            min={0}
            name="age"
          />
        </div>
        <div>
          <span>
            Joining Date<span style={{ color: "red" }}>*</span>
          </span>
          <input
            value={memberData.joining_date}
            onChange={handleAddChange}
            className="input-class"
            max={todayDate}
            type="date"
            name="joining_date"
          />
        </div>
        <div>
          <span>
            Experience<span style={{ color: "red" }}>*</span>
          </span>
          <input
            value={memberData.experience}
            onChange={handleAddChange}
            className="input-class"
            min={0}
            type="number"
            name="experience"
          />
        </div>
        <div>
          <span>
            Qualification<span style={{ color: "red" }}>*</span>
          </span>
          <select
            value={memberData.qualifications[0]?.degree || ""}
            onChange={(e) => {
              const degree = e.target.value;
              setMemberData((prev) => ({
                ...prev,
                qualifications: [{ degree }],
              }));
            }}
            className="input-class"
            name="qualifications"
          >
            <option hidden value="">
              Select an Option
            </option>
            {enumsData?.data?.qualification &&
              Object.entries(enumsData.data.qualification).map(
                ([key, value]) => (
                  <option key={key} value={value}>
                    {value}
                  </option>
                )
              )}
          </select>
        </div>
        <div>
          <span>
            Password<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            className="input-class"
            type="password"
            name="pwd"
            value={memberData.pwd}
          />
        </div>
        <div>
          <span>
            Confirm Password<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={(event) => {
              setConfirmPass(event.target.value);
            }}
            onBlur={handleCheckPass}
            className="input-class"
            type="password"
            value={confirmPass}
          />
        </div>
        <div className="span2">
          <span>
            Branch Address<span style={{ color: "red" }}>*</span>
          </span>
          <input
            value={memberData.branch_address}
            onChange={handleAddChange}
            className="input-class"
            type="text"
            name="branch_address"
          />
        </div>
        <div className="address-document-container">
          <div style={{ width: "50%" }}>
            <h3>Address Details</h3>
            <div className="address-details">
              <div style={{ position: "relative" }}>
                <div>
                  <span>
                    Street Address<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    value={memberData.address}
                    onChange={handleAddChange}
                    className="input-class"
                    type="text"
                    name="address"
                  />
                </div>
                <div className="flex-container gap-10">
                  <div style={{ width: "50%" }}>
                    <span>
                      Country<span style={{ color: "red" }}>*</span>
                    </span>
                    <select
                      className="input-class"
                      name="country"
                      onChange={handleAddChange}
                      value={memberData.country}
                    >
                      <option hidden value="">
                        Select a Country
                      </option>
                      {countryList?.data?.map((country) => (
                        <option key={country._id} value={country._id}>
                          {country.country_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ width: "50%" }}>
                    <span>
                      State<span style={{ color: "red" }}>*</span>
                    </span>
                    <select
                      disabled={memberData.country ? false : true}
                      className="input-class"
                      name="state"
                      onChange={handleAddChange}
                      value={memberData.state}
                    >
                      <option hidden value="">
                        Select a State
                      </option>
                      {states?.data?.map((state) => (
                        <option key={state._id} value={state._id}>
                          {state.state_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="flex-container gap-10">
                  <div style={{ width: "50%" }}>
                    <span>
                      City<span style={{ color: "red" }}>*</span>
                    </span>
                    <select
                      className="input-class"
                      name="city"
                      disabled={memberData.state ? false : true}
                      onChange={handleAddChange}
                      value={memberData.city}
                    >
                      <option hidden value="">
                        Select a City
                      </option>
                      {cities?.data?.map((city) => (
                        <option key={city._id} value={city._id}>
                          {city.city_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ width: "50%" }}>
                    <span>
                      Zip Code<span style={{ color: "red" }}>*</span>
                    </span>
                    <input
                      onChange={handleAddChange}
                      className="input-class"
                      type="text"
                      value={memberData.zip_code}
                      name="zip_code"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ width: "50%" }}>
            <h3>Documents Details</h3>
            <div className="documents-details flex-container flex-column gap-10">
              <div style={{ position: "relative" }}>
                <span>
                  Identity Proof(1)<span style={{ color: "red" }}>*</span>
                </span>
                <input
                  className="input-class"
                  onChange={handleNameChange}
                  type="text"
                  value={memberData.document_list?.[0]?.name || ""}
                  name="name"
                />
              </div>
              <input
                type="file"
                name="url"
                onChange={(event) => handleFileChange(event, 0)}
              />
            </div>
          </div>
        </div>
        <div style={{ paddingTop: "20px" }} className="bank-details span2">
          <div className="bank-details-section">
            <h3>Bank Details</h3>
            <div className="bank-details-form">
              <div className="form-group">
                <label>
                  Account Number<span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="acc_num"
                  value={memberData.bank_details[0].acc_num}
                  onChange={handleBankDetails}
                  className="input-class"
                  style={{ width: "125%" }}
                />
              </div>
              <div className="form-group">
                <label>
                  Re-Enter Account Number<span className="required">*</span>
                </label>
                <input
                  type="text"
                  value={reAccount}
                  onChange={(e) => setReAccount(e.target.value)}
                  onBlur={handleCheckAcc}
                  className="input-class"
                  style={{ width: "125%" }}
                />
              </div>
              <div className="form-group">
                <label>
                  IFSC Code<span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="ifsc"
                  value={memberData.bank_details[0].ifsc}
                  onChange={handleBankDetails}
                  className="input-class"
                  disabled={!accMatch}
                  style={{ width: "125%" }}
                />
              </div>
              <div className="form-group">
                <label>
                  Account Holder Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="acc_holder_name"
                  value={memberData.bank_details[0].acc_holder_name}
                  onChange={handleBankDetails}
                  className="input-class"
                  disabled={!accMatch}
                  style={{ width: "125%" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex-container gap-10 flex-end margin-h-10 span2">
          <Link to="/team">
            <button className="button-class-white">Cancel</button>
          </Link>
          <button onClick={handleSubmit} className="button-class">
            Save
          </button>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddTeamMember;
